import { createSelector } from '@reduxjs/toolkit'
import { InAppNotificationType } from 'pure-js/enums/InAppNotificationType'
import type { RootState } from '../store'

export const selectInAppNotificationsList = (state: RootState) => state.inAppNotifications.notifications

/** Unviewed GAME_REMINDER notifications (backend-driven). */
export const selectUnviewedGameReminders = createSelector([selectInAppNotificationsList], (notifications) =>
  notifications.filter((n) => n.type === InAppNotificationType.GAME_REMINDER && !n.viewedAt)
)

/** Unviewed REPORT_READY notifications (facilitator). */
export const selectUnviewedReportReadyNotifications = createSelector([selectInAppNotificationsList], (notifications) =>
  notifications.filter((n) => n.type === InAppNotificationType.REPORT_READY && !n.viewedAt)
)

/** Unviewed SENT_TO_ACTIVITY notifications (gamer), newest first: where a facilitator sent the team. */
export const selectUnviewedSentToActivity = createSelector([selectInAppNotificationsList], (notifications) =>
  notifications.filter(
    (notification) => notification.type === InAppNotificationType.SENT_TO_ACTIVITY && !notification.viewedAt
  )
)

/** Unviewed FEEDBACK_READY notifications (gamer). */
export const selectUnviewedFeedbackReadyNotifications = createSelector(
  [selectInAppNotificationsList],
  (notifications) => notifications.filter((n) => n.type === InAppNotificationType.FEEDBACK_READY && !n.viewedAt)
)
